import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow, ItemIcon } from "@similarweb/ui-components";

const { carbon, blue } = colorsPalettes;

export const TextContainer = styled.div`
    text-align: center;
    max-width: 500px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-left: 8px;
    margin-right: 4px;

    ${setFontVariant("h5_2", carbon[500])};
`;

export const CustomItemIcon = styled(ItemIcon)`
    height: 24px;
    width: 24px;
`;

export const IconContainer = styled(FlexRow)`
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
`;

export const DropdownIcon = styled(SWReactIcons)`
    display: flex;
    align-items: center;
`;

export const FlatButtonWrapper = styled(FlexRow)`
    align-items: center;
    padding: 8px 0;
    margin-right: 16px;
    cursor: pointer;
    border-bottom: 1px solid ${carbon[500]};

    &:hover {
        ${TextContainer} {
            color: ${blue[500]};
        }
        ${DropdownIcon} {
            path {
                fill: ${blue[500]};
            }
        }
        border-bottom: 1px solid ${blue[500]};
    }
`;
